import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sizeTransform' })
export class SizeTransformPipe implements PipeTransform {
  transform(size: string) {
    return size ? `size-${size[0]}-${size[2]}` : '';
  }
}
